import type { Message, OpenWindowState } from '../types/types';
import { MessageType, OpenTableAction } from '../types/types';
import { ACTIVE_TABLE_CHANNEL_NAME, openOrFocusTab } from '../utils/utils';

export class BroadcastChannelCommunication {
  private channel: BroadcastChannel;
  private broadcastAfterOpen: Message | undefined;

  constructor(parameters?: { name?: string }) {
    this.channel = new BroadcastChannel(parameters?.name || ACTIVE_TABLE_CHANNEL_NAME);

    this.onMessage((message) => {
      if (message.type === MessageType.HANDSHAKE) {
        this.handleHandshake();
      }
    });
  }

  private handleHandshake() {
    if (this.broadcastAfterOpen) {
      this.postMessage(this.broadcastAfterOpen);
      this.broadcastAfterOpen = undefined;
    }
  }

  private postMessage(message: Message) {
    this.channel.postMessage(message);
  }

  private onMessage(callback: (message: Message) => void) {
    this.channel.onmessage = (event) => {
      callback(event.data);
    };
  }

  openTableWindow(url: string, message?: Message): OpenWindowState {
    const result = openOrFocusTab(url);

    switch (result.action) {
      case OpenTableAction.OPEN:
        this.broadcastAfterOpen = message;
        break;
      case OpenTableAction.FOCUS:
        if (message) {
          this.postMessage(message);
        }
        break;
    }

    return result;
  }
}
